const RESP_OPTIONS = ["", "By CleanSpace", "By Others", "N/A"];
const LD_OPTIONS   = ["", "Applicable", "Not Applicable"];
const AHJ_OPTIONS  = ["", "Yes — see notes", "No known AHJ requirements"];

export default function PermitsTermsPanel({ permitsTerms, setPermitsTerms, onSave, saving }) {
  function termField(label, field, options, helpText) {
    return (
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text2)", marginBottom: 4 }}>
          {label}
        </div>
        {helpText && (
          <div style={{ fontSize: 11, color: "var(--text3)", marginBottom: 6 }}>{helpText}</div>
        )}
        <select
          value={permitsTerms[field] || ""}
          onChange={e => {
            const updated = { ...permitsTerms, [field]: e.target.value };
            if (field === "ld" && e.target.value !== "Applicable") updated.ld_terms = "";
            setPermitsTerms(updated);
            onSave(updated);
          }}
          disabled={saving}
          style={{
            width: "100%", padding: "7px 10px", fontSize: 13,
            border: "1px solid var(--cs-border)", borderRadius: 6,
            background: "var(--surface)", color: !permitsTerms[field] ? "var(--text3)" : "var(--text)",
            opacity: saving ? 0.6 : 1,
          }}
        >
          {options.map(o => (
            <option key={o} value={o} style={{ color: o ? "" : "var(--text3)" }}>
              {o || "— Select —"}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: 24, padding: "16px 18px", background: "#f8f9fb", border: "1px solid var(--cs-border)", borderRadius: 10 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", marginBottom: 16 }}>
        Contract Terms
      </div>
      {termField("Permits", "permits", RESP_OPTIONS, "Who is responsible for pulling and maintaining all required permits?")}
      {termField("Performance & Payment Bonds", "bonds", RESP_OPTIONS, "Are performance or payment bonds required, and who provides them?")}
      {termField("Liquidated Damages", "ld", LD_OPTIONS, "Do the contract documents include LD provisions?")}
      {permitsTerms.ld === "Applicable" && (
        <div style={{ marginBottom: 16, marginTop: -8 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text2)", marginBottom: 4 }}>
            LD Terms <span style={{ fontWeight: 400, color: "var(--text3)" }}>— enter rate, cap, and trigger conditions</span>
          </div>
          <textarea
            value={permitsTerms.ld_terms || ""}
            onChange={e => setPermitsTerms(prev => ({ ...prev, ld_terms: e.target.value }))}
            onBlur={() => onSave(permitsTerms)}
            placeholder="e.g. $1,000/day after Oct 22, 2026 Substantial Completion date; cap at 10% of contract value"
            rows={3}
            style={{
              width: "100%", padding: "8px 10px", fontSize: 13,
              border: "1px solid var(--cs-border)", borderRadius: 6,
              resize: "vertical", boxSizing: "border-box",
              background: "var(--surface)", color: "var(--text)",
              fontFamily: "inherit", lineHeight: 1.5, outline: "none",
            }}
          />
        </div>
      )}
      {termField("AHJ Requirements", "ahj", AHJ_OPTIONS, "Are there authority-having-jurisdiction requirements beyond standard permitting?")}
      {permitsTerms.ahj === "Yes — see notes" && (
        <div style={{ marginBottom: 4, marginTop: -8 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text2)", marginBottom: 4 }}>
            AHJ Notes
          </div>
          <textarea
            value={permitsTerms.ahj_notes || ""}
            onChange={e => setPermitsTerms(prev => ({ ...prev, ahj_notes: e.target.value }))}
            onBlur={() => onSave(permitsTerms)}
            placeholder="Describe AHJ requirements, jurisdictional specifics, inspection requirements, etc."
            rows={3}
            style={{
              width: "100%", padding: "8px 10px", fontSize: 13,
              border: "1px solid var(--cs-border)", borderRadius: 6,
              resize: "vertical", boxSizing: "border-box",
              background: "var(--surface)", color: "var(--text)",
              fontFamily: "inherit", lineHeight: 1.5, outline: "none",
            }}
          />
        </div>
      )}
      {saving && (
        <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 4 }}>Saving…</div>
      )}
    </div>
  );
}
